import { render } from "./BlFormFieldSignatureDialog.vue?vue&type=template&id=81d06e6e&scoped=true"
import script from "./BlFormFieldSignatureDialog.vue?vue&type=script&lang=js"
export * from "./BlFormFieldSignatureDialog.vue?vue&type=script&lang=js"

import "./BlFormFieldSignatureDialog.vue?vue&type=style&index=0&id=81d06e6e&scoped=true&lang=scss"

import exportComponent from "/tmp/f3315f41-3418-4066-838e-b0c15008937b/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81d06e6e"]])

export default __exports__